import React from 'react';
import NewUserButton from './common/new-user-button';

const AlreadySetUpView = ({
    onBackToLogin,
    onRequestPasswordReset,
}: {
    onBackToLogin: () => void;
    onRequestPasswordReset: () => void;
}) => (
    <div className="already-set-up-page">
        <div className="new-user-view-content">
            <div className="new-user-view-box">
                <p className="new-user-password-reset-requested-text">
                    Your account is already set up. If you remember your username and password, you
                    can log in with them now. Otherwise you can request a password reset from your
                    teacher
                </p>
                <div className="new-user-view-form-button-group new-user-choose-password-btn-group">
                    <NewUserButton
                        type="button"
                        value="Back to login"
                        handleClick={onBackToLogin}
                    />
                    <NewUserButton
                        type="submit"
                        value="Request reset"
                        showIcon={false}
                        handleClick={() => {
                            onRequestPasswordReset();
                        }}
                    />
                </div>
            </div>
        </div>
    </div>
);

export default AlreadySetUpView;
